import { isServer as r, QueryClient as n } from "@tanstack/react-query";
import * as i from "ramda";
let e = null;
const t = () => new n({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1e3
    }
  }
}), s = () => r ? t() : (e = i.isNotNil(e) ? e : t(), e);
export {
  s as getClient
};
//# sourceMappingURL=index.js.map
